import {
  emailRequired,
  optionalPhoneNumber,
  phoneNumber,
} from "@covertree/utils";
import { boolean, object, string } from "yup";

export interface EditContactForm {
  emailAddress?: string;
  primaryContactNumber: string;
  secondaryContactNumber?: string | null;
  noEmail: boolean;
}

export const contactValidation = (emailDisabled: boolean | undefined) =>
  object({
    noEmail: boolean(),
    emailAddress: string().when("extras.noEmail", ([noEmail]) =>
      noEmail || emailDisabled ? string().optional() : emailRequired()
    ),
    primaryContactNumber: phoneNumber().required(
      "Primary phone number is required"
    ),
    secondaryContactNumber: optionalPhoneNumber(),
  });
